<template>
    <div class="list-merge-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Merge Lists</h3>
                <div class="svg-container widget-close-button" @click="closeWidget()">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-svg v-if="isMerging" />
                <div v-else>
                    <div class="intro-container">
                        <p>Which list(s) would you like to merge into {{list.name}}?</p>
                    </div>  
                    <div class="list-trigger-container">
                        <div class="list-label">
                            Choose your list
                        </div>

                        <div class="list-input-container">
                            <list-search 
                                :mergingListId="this.options.listId"
                                :clientId="this.options.clientId"
                                @input="addList($event)" />
                            <div class="lists">
                                <div class="list" 
                                    v-for="list in selectedLists" 
                                    :key="list.id">
                                    {{ list.name }} 
                                    <widget-close-svg @click.native="removeList(list)" class="delete-list" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget()">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button
                        @click="mergeList()">
                        Merge
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppButton = () => import('@/components/common/app-button');
const LoadingSvg = () => import('@/components/svg/loading-screen-svg');
const Multiselect = () => import('vue-multiselect');
const ListSearch = () => import('@/components/list/list-search');

import EventBus from '@/scripts/event-bus.js';
    
export default {
    name: 'list-merge-widget',

    props: {
        options: {
            type: Object
        },
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
        'loading-svg': LoadingSvg,
        'list-search': ListSearch,
    },
    
    data() {
        return {
            list: {
                name: null
            },
            selectedLists: [],
            isMerging: false
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        addList(newList) {
            var exists = this.selectedLists.some(list => {
                return list.id === newList.id;
            });

            if (!exists) {
                this.selectedLists.push(newList);
            }
        },

        mergeList() {
            this.isMerging = true;

            var request = {
                ListId: this.options.listId,
                SelectedMergeListIds: this.selectedListIds,
                ClientId: this.options.clientId
            };

            this.$api
                .post(`/api/Lists/Merge`, request)
                .then(response => {
                    this.$helpers.showSuccessNotification('The lists have been merged');
                    this.closeWidget();
                    EventBus.$emit('list:update');
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while merging your list.', { error });
                })
                .finally(()=>{
                    this.isMerging = false;
                });
        },

        removeList(index) {
            this.selectedLists.splice(index, 1);
        }
    },
    computed: {
        selectedListIds(){
            return this.selectedLists.map(list => list.id);
        }

    }
}
</script>

<style>
.list-merge-widget .loading-screen {
    width: 100% ;
    text-align: center;
}

.list-merge-widget .list-input-container {
    border: 2px solid #E9E9EF;
    border-radius: 22px;
    padding: 22px 56px;
}

.list-merge-widget .list-trigger-container {
    margin-bottom: 30px;
}

.list-merge-widget .list-input-container .lists .list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #877D88;
    border-radius: 20px;
    font-size: 16px;
    color: #ffffff;
    padding: 11px 15px;
    margin-top: 11px;
}

.list-merge-widget .list-label {
    position: relative;
    bottom: -12px;
    width: fit-content;
    background:#ffffff;
    margin: 0 auto;
    font-weight: 500;
    padding: 0 47px;
}

.list-merge-widget .delete-list {
    cursor: pointer;
}

.list-merge-widget .content-container {
    height: 100%;
}
</style>